// extracted by mini-css-extract-plugin
export default {"schema_display_container":"SchemaDisplayPage_schema_display_container__83VP9"};